export default "__VITE_ASSET__Blb8RFj7__"